
<div class="user-select-cont">

  <div class="tab-container" (click)="selectedTab = this.tabTypes.dropdown">
    <div class="form-label" fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_DELEGATE"></div>
  </div>
  <div [class.is_disabled]="this.tabTypes.dropdown !== selectedTab">
    <div class="user-select" [class.active]="selectActive">
      <div class="user-select-input" (click)="toggleSelect($event)">
        <img src="assets/icons/search.svg" alt="search" class="search-icon">
        <input type="text" maxlength="500" class="select-input" [(ngModel)]="searchedText"
          (blur)="searchedText = currentSearchText"
          (click)="showSelect($event)" (keyup)="doSearch()" [isPLaceHolder]="true"
          fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_DELEGATE_PLACEHOLDER">
        <img src="assets/icons/arrow-down-dark.svg" alt="arrow" class="arrow" (click)="toggleSelect($event)">
      </div>

      <div class="options">
        <div class="options-inner">
          @if (suggestedData.byArea?.length) {
            <div class="result-by-area result-cont">
              <p class="title" fiTranslation="ACTION_LEAD_FORWARD_SEARCH_SUGGESTION_USER"></p>
              @for (result of suggestedData.byArea; track result) {
                <div class="result-item"
                  (click)="selectResultItem($event, result)">
                  <span class="name result-part">{{result.FirstName + ' ' + result.LastName}}</span>
                  <span class="organisation result-part">{{result.Organisation}}</span>
                </div>
              }
            </div>
          }
          <div class="result-by-hierarchy result-cont">
            <p class="title" fiTranslation="ACTION_LEAD_FORWARD_SEARCH_ALL_USER"></p>

            @for (result of suggestedData.byHierarchy; track result) {
              <div class="result-item"
                (click)="selectResultItem($event, result)">
                <span class="name result-part">{{result.FirstName + ' ' + result.LastName}}</span>
                <span class="organisation result-part">{{result.Organisation}}</span>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="select-overlay" [class.active]="selectActive"></div>
    </div>
  </div>
</div>

@if (selectActive) {
  <div class="overlay active" (click)="selectActive = !selectActive; searchedText = currentSearchText"></div>
}

